import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73de5ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lost-found-container" }
const _hoisted_2 = {
  ref: "containerWrapper",
  class: "content-wrapper"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "상태", -1 /* HOISTED */))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "습득물명", -1 /* HOISTED */))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "습득노선", -1 /* HOISTED */))
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "습득일시", -1 /* HOISTED */))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "보관장소", -1 /* HOISTED */))
const _hoisted_16 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "습득물" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            ($setup.lostFoundDetail?.statusCode)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(["status", [$setup.lostFoundStatusCodeMap[$setup.lostFoundDetail.statusCode]]])
                }, _toDisplayString($setup.lostFoundDetail?.statusName), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString($setup.lostFoundDetail?.title), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, _toDisplayString($setup.lostFoundDetail?.lineRouteName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString($setup.lostFoundDetail?.foundTs), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, _toDisplayString($setup.lostFoundDetail?.storeLocationName), 1 /* TEXT */)
          ])
        ], 512 /* NEED_PATCH */),
        _createVNode($setup["FooterButton"], {
          title: "목록",
          onOnClickFooterButton: $setup.goBack
        })
      ]),
      ($setup.containerWrapper)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            class: "scroll-top-wrapper",
            container: $setup.containerWrapper
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}